export default "<p>listdevicepos works!</p>\n";